var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"user-avatar rounded-full",style:({
    minWidth: _vm.overWriteMinLimit ? '' : '32px',
    minHeight: _vm.overWriteMinLimit ? '' : '32px'
  }),attrs:{"src":_vm._f("replaceBucketUrlWithCdnUrl")(_vm.src),"alt":"user avatar"}})}
var staticRenderFns = []

export { render, staticRenderFns }